import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from "../utils/index";
Vue.use(VueRouter)

let routes = [
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/dashboard',
	},
	{
		path: '/dashboard',
		name: '首页',
		layout: "dashboard",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
	},
	{
		path: '/layout',
		name: 'Layout',
		layout: "dashboard",
		component: () => import('../views/Layout.vue'),
	},
	{
		path: '/website',
		name: '落地页',
		layout: "dashboard",
		meta: {
            permission: 'admin' // 表示该路由需要具有 'admin' 权限才能访问
        },
		component: () => import('../views/website/index.vue'),
	},
	{
		path: '/workorder',
		name: '用户管理',
		layout: "dashboard",
		meta: {
            permission: 'admin' // 表示该路由需要具有 'admin' 权限才能访问
        },
		component: () => import('../views/workorder/index.vue'),
	},
	{
		path: '/template',
		name: '模板管理',
		layout: "dashboard",
		meta: {
            permission: 'admin' // 表示该路由需要具有 'admin' 权限才能访问
        },
		component: () => import('../views/template/index.vue'),
	},
	{
		path: '/billing',
		name: '账单',
		layout: "dashboard",
		component: () => import('../views/Billing.vue'),
	},
	{
		path: '/rtl',
		name: 'RTL',
		layout: "dashboard-rtl",
		meta: {
			layoutClass: 'dashboard-rtl',
		},
		component: () => import('../views/RTL.vue'),
	},
	{
		path: '/Profile',
		name: '个人信息',
		layout: "dashboard",
		meta: {
			layoutClass: 'layout-profile',
		},
		component: () => import('../views/Profile.vue'),
	},
	{
		path: '/accounts',
		name: '账号管理',
		layout: "dashboard",
		meta: {
			layoutClass: 'layout-profile',
		},
		component: () => import('../views/Profile.vue'),
	},
	
	{
		path: '/sign-in',
		name: 'Sign-In',
		component: () => import('../views/Sign-In.vue'),
	},
	{
		path: '/sign-up',
		name: 'Sign-Up',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../views/Sign-Up.vue'),
	},
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute( route, parentLayout = "default" )
{
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children )
	{
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) ) ;
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.hash ) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const token = getToken(); // 获取 token
    // 如果 token 不存在且不在登录页面，则跳转到登录页面
    if (!token && to.path !== '/sign-in') {
        next('/sign-in');
    }else {
		next(); // 有权限则继续导航
	}
});


export default router
